// extracted by css-extract-rspack-plugin
export default {"Avatar":"AppSwitcher-module__Avatar___r7FNc"};